import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
    html, body, div, span, applet, object, iframe,
    blockquote, pre,
    a, abbr, acronym, address, big, cite, code,
    del, dfn, em, img, ins, kbd, q, s, samp,
    small, strike, sub, sup, tt, var,
    u, i, center,
    dl, dt, dd, menu,
    fieldset, label, legend,
    table, caption, tbody, tfoot, thead, tr, th, td,
     aside, canvas, details, embed,
    figure, figcaption, footer, header, hgroup,
    main, menu, nav, output, ruby, section, summary,
    time, mark, audio, video {
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 100%;
        font: inherit;
        vertical-align: baseline;
        font-family: Arial, sans-serif;
        line-height: 1.2; /* 줄 간격을 1.5배로 설정 */
    }
    
    form {
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 100%;
        font: inherit;
        vertical-align: baseline;
        font-family: Arial, sans-serif;
        line-height: 1.2; /* 줄 간격을 1.5배로 설정 */
        width: 640px;
        @media (max-width: 768px) {
            width: 100%;
            
        }
    }

    h1, h2, h3, h4, h5, h6 {
        vertical-align: baseline;
        font-family: Arial, sans-serif;
        line-height: 1.3;
    }
    
    b, strong {
        vertical-align: baseline;
        font-family: Arial, sans-serif;
        line-height: 1.2;
    }
    
    img {
        max-width: 100%;
        margin: 8px 0;
        height: auto;
        display: block;
    }
    /* HTML5 display-role reset for older browsers */
    article, aside, details, figcaption, figure,
    footer, header, hgroup, main, menu, nav, section {
        display: block;
    }

    /* HTML5 hidden-attribute fix for newer browsers */
    *[hidden] {
        display: none;
    }

    body {
        line-height: 1;
        background-color: #EEEEEE;
    }
    
    p {
        font-size: 13px;
        vertical-align: baseline;
        font-family: Arial, sans-serif;
        line-height: 1.5;
        margin: 4px 0;
    }


    ul {
        margin: 0;
    }

    li {
        font-size: 13px;
        vertical-align: baseline;
        font-family: Arial, sans-serif;
        line-height: 1.3;
        margin: 4px 0;
    }
    
    menu {
        list-style: none;
    }

    blockquote, q {
        quotes: none;
    }

    blockquote:before, blockquote:after,
    q:before, q:after {
        content: '';
        content: none;
    }

    table {
        border-collapse: collapse;
        border-spacing: 0;
    }

    article
    {
        display: block;
        height: 30px;
        padding: 0;
        margin: 0;
    }
`;

export default GlobalStyle;
